import React, {Fragment, useState} from "react";
import {Col, Form, Row, Select, Input} from "antd";
import {FormattedMessage} from "react-intl";
import {
  Video,
  VideoContentStatus,
  VideoContentTypeOptions
} from "@models/video-content";
import VideoSelection from "@components/video-contents/Selection";
import {SelectionMode} from "@models";
import {Image} from "@models/image";
import ImagePicker from "@components/custom/imagePicker";

const {Option} = Select;

interface SliderProps {
  selectedVideo: Video | null;
  selectedImage: Image | null;
}

const WidgetItemVideoSelection: React.FC<SliderProps> = props => {
  const {form, selectedVideo, selectedImage} = props;
  const [videoType, setVideoContentType] = useState(
    selectedVideo ? selectedVideo.type : null
  );
  const [video, setVideo] = useState(selectedVideo || null);

  const onChangeType = type => {
    setVideoContentType(type);
    setVideo(null);
  };

  const onSelectVideo = (video: Video) => {
    setVideo(video);
    form.setFieldsValue({
      content_id: video.id,
      video_content: video
    });
  };

  return (
    <Fragment>
      <Form.Item className={"no-label"}>
        {form.getFieldDecorator("video_content", {
          initialValue: video
        })(<Input type={`hidden`}/>)}
      </Form.Item>
      <Row gutter={24}>
        <Col span={12}>
          <Form.Item
            label={<FormattedMessage id="app.type" defaultMessage={`Type`}/>}
          >
            {form.getFieldDecorator("content_type", {
              initialValue: videoType
            })(
              <Select onChange={onChangeType}>
                {VideoContentTypeOptions.map((opt, index) => (
                  <Option key={index} value={opt.value}>
                    {opt.label}
                  </Option>
                ))}
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label={
              <FormattedMessage
                id="app.select_video"
                defaultMessage={`Select Video`}
              />
            }
          >
            {form.getFieldDecorator("content_id", {
              initialValue: video ? video.id : null,
              rules: [
                {
                  required: true,
                  message: (
                    <FormattedMessage
                      id="app.video_is_required"
                      defaultMessage={`Select video!`}
                    />
                  )
                }
              ]
            })(<Input type={`hidden`}/>)}
            <VideoSelection
              key={videoType}
              filter={{
                video_content_type: videoType,
                status: VideoContentStatus.ACTIVE
              }}
              disabled={videoType ? false : true}
              mode={SelectionMode.DEFAULT}
              onChange={onSelectVideo}
              initialValue={video}
            />
          </Form.Item>
        </Col>
      </Row>
    </Fragment>
  );
};

export default WidgetItemVideoSelection;
